/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { Memo } from '@src/app/model/memo';
import { IsNarrowService } from '@src/app/shared/is-narrow.service';
import { MemoField } from "@src/app/shared/memos/MemoField";
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { EditorComponent } from '@tinymce/tinymce-angular';

@Component({
    selector: 'app-new-memo',
    templateUrl: './new-memo.component.html',
    styleUrls: ['./new-memo.component.scss'],
    imports: [MatDialogContent, EditorComponent, FormsModule, ReactiveFormsModule, MatButtonModule, MatIconModule]
})
export class NewMemoComponent implements OnInit {
    data = inject<{
    field: MemoField;
    memo: Memo;
}>(MAT_DIALOG_DATA);
    private dialogRef = inject<MatDialogRef<NewMemoComponent>>(MatDialogRef);
    private isNarrowSvc = inject(IsNarrowService);


    width = 500;
    height = 300;

    noteControl = new FormControl();

    editorOptions = {
         
        height: "300",
        menubar: false,
        relative_urls: false,
        statusbar: false,
        remove_script_host: false,

        plugins: [
            'advlist autolink lists link charmap print preview anchor',
            'searchreplace visualblocks code',
            'insertdatetime paste help'
        ],

        toolbar: 'bold italic link | outdent indent bullist numlist',

        setup: (ed) => {
            ed.on('init', () => {

                this.data.field.control.markAsPristine();
                ed.getBody().style.backgroundColor = 'rgba(243, 242, 241, 1)';
            });
        }
    };

    constructor() {
        const data = this.data;

        this.isNarrowSvc.resizeObservable$.subscribe(() => this.setSize());
        if (data.memo) {
            this.noteControl.setValue(data.memo.memo);
        }

    }

    ngOnInit(): void {
        this.setSize();
    }

    setSize(): void {
        this.width = this.isNarrowSvc.screenWidth * .75;
        this.height = this.isNarrowSvc.screenHeight * .65;
    }

    saveNote() {
        const fld = this.data.field;

        if (this.data.memo) {
            this.data.memo.memo = this.noteControl.value;
            fld.service.putMemo(this.data.memo).subscribe(updatedMemo => {
                this.data.memo.memo = updatedMemo.memo;
                this.dialogRef.close(updatedMemo);
            })
        } else {
            fld.service.postMemo(this.noteControl.value, fld.relatedId, fld.relatedTeamId).subscribe(newNote => {
                //fld.control.addRow(newNote, true,true);
                this.dialogRef.close(newNote);
            })
        }

    }

    getTitle() {
        return this.data.field.getTitle(this.data.memo);
    }

    closeDialog() {
        console.log('Close Dialog');
        this.dialogRef.close(null);
    }
}
